module.exports = __webpack_public_path__ + "static/mr-concert-performance-31-32161dfe88ea9d24f69dc1617266d9b8.jpg";